import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

const authService = () => inject(AuthService);
const showAccessDeniedPage = () => inject(Router).createUrlTree(['/access-denied']);

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      return authService().hasPermission('UI.TechnicianServiceSchedule')
        ? '/service-schedule'
        : '/my-appointments';
    },
  },
  {
    path: 'my-appointments',
    canActivate: [
      () => authService().hasPermission('UI.EmployeeAppointments') || showAccessDeniedPage(),
    ],
    children: [
      {
        path: '',
        title: 'ROUTES.MY_APPOINTMENTS',
        loadComponent: () =>
          import('./pages/my-appointments/my-appointments-list/my-appointments-list.component').then(
            (m) => m.MyAppointmentsList,
          ),
      },
      {
        path: 'new',
        title: 'APPOINTMENTS.NEW.PAGE_TITLE',
        loadComponent: () =>
          import('./pages/my-appointments/new-appointment/new-appointment.component').then(
            (m) => m.NewAppointment,
          ),
      },
      {
        path: 'confirmed',
        title: 'APPOINTMENTS.NEW.PAGE_TITLE',
        data: { fullWidth: true },
        loadComponent: () =>
          import('./pages/my-appointments/booking-confirmation/booking-confirmation.component').then(
            (m) => m.BookingConfirmation,
          ),
      },
      {
        path: 'reschedule/:id',
        title: 'APPOINTMENTS.RESCHEDULE.PAGE_TITLE',
        loadComponent: () =>
          import('./pages/my-appointments/new-appointment/new-appointment.component').then(
            (m) => m.NewAppointment,
          ),
      },
    ],
  },
  {
    path: 'call-in-reqs',
    title: 'ROUTES.CALL_IN_REQS',
    canActivate: [
      () => authService().hasPermission('UI.TechnicianCallInReqs') || showAccessDeniedPage(),
    ],
    loadComponent: () =>
      import('./pages/call-in-reqs/call-in-reqs-list/call-in-reqs-list.component').then(
        (m) => m.CallInRequestsList,
      ),
  },
  {
    path: 'service-schedule',
    title: 'ROUTES.SERVICE_SCHEDULE',
    canActivate: [
      () => authService().hasPermission('UI.TechnicianServiceSchedule') || showAccessDeniedPage(),
    ],
    loadComponent: () =>
      import('./pages/service-schedule/service-schedule/service-schedule.component').then(
        (m) => m.ServiceSchedule,
      ),
  },
  {
    path: 'access-denied',
    title: 'ROUTES.ACCESS_DENIED',
    data: { variant: 'access-denied' },
    loadComponent: () =>
      import('./shared/components/error-page/error-page.component').then((m) => m.ErrorPage),
  },
  {
    path: '**',
    title: 'ROUTES.PAGE_NOT_FOUND',
    data: { variant: 'not-found' },
    loadComponent: () =>
      import('./shared/components/error-page/error-page.component').then((m) => m.ErrorPage),
  },
];
